import SVGDownCaret from 'visitor-ui-component-library-icons/icons/SVGDownCaret';
import { createThemeV2 } from 'visitor-ui-component-library/theme/createThemeV2';
import VizExIconButton from 'visitor-ui-component-library/button/VizExIconButton';
import VizExIcon from 'visitor-ui-component-library/icon/VizExIcon';
import styled, { css, keyframes } from 'styled-components';
import { adjustLuminance } from 'visitor-ui-component-library/utils/adjustLuminance';
import { trackInteraction } from '../../usage-tracking/actions/trackInteraction';
import { useDispatch } from 'react-redux';
import { EVENT_NAMES } from '../../usage-tracking/constants/eventNames';
import { jsx as _jsx } from "react/jsx-runtime";
const fadeIn = keyframes(["0%{opacity:0;}50%{opacity:0;}75%{opacity:.5}100%{opacity:1;}"]);
const fadeOut = keyframes(["0%{opacity:1;}50%{opacity:1;}75%{opacity:.5}100%{opacity:0;}"]);
const StyledIconButton = styled(VizExIconButton).withConfig({
  displayName: "ScrollToButton__StyledIconButton"
})(["position:absolute;bottom:12px;left:12px;animation:", ";animation-duration:300ms;animation-timing-function:", ";"], ({
  showScrollTo
}) => showScrollTo ? fadeIn : fadeOut, ({
  showScrollTo
}) => showScrollTo ? 'ease-in' : 'ease-out');
const themeOverride = accentColor => createThemeV2({
  components: {
    IconButton: {
      baseStyle: css(["width:24px;height:24px;display:inline-flex;align-items:center;justify-content:center;border-radius:50%;border:1px solid ", ";background-color:#fff;"], accentColor),
      _hovered: css(["background-color:", ";"], adjustLuminance(accentColor, 95)),
      _pressed: css(["background-color:", ";"], adjustLuminance(accentColor, 90))
    }
  }
});
function ScrollToButton({
  onClick,
  onAnimationEnd,
  coloring,
  showScrollTo
}) {
  const {
    accentColor
  } = coloring;
  const dispatch = useDispatch();
  function handleClick() {
    onClick();
    dispatch(trackInteraction(EVENT_NAMES.WIDGET_INTERACTION, {
      action: 'clicked scroll to button'
    }, true));
  }
  return /*#__PURE__*/_jsx(StyledIconButton, {
    theme: themeOverride(accentColor),
    size: "sm",
    shape: "circle",
    use: "primary",
    onClick: handleClick,
    onAnimationEnd: onAnimationEnd,
    showScrollTo: showScrollTo,
    "aria-hidden": true,
    children: /*#__PURE__*/_jsx(VizExIcon, {
      icon: /*#__PURE__*/_jsx(SVGDownCaret, {
        fill: accentColor
      }),
      size: "xs"
    })
  });
}
ScrollToButton.displayName = 'ScrollToButton';
export default ScrollToButton;